import {InventoryMainSprite} from "./InventoryMain.sprite";
import {InventoryController} from "../controllers/inventory.controller";

export class Spriteset_InventoryUI extends Sprite {
  constructor() {
    super();
    this._initEU();
  }

  _initEU() {
    this._inventorySprite = new InventoryMainSprite();
    this.inventory = new InventoryController(this._inventorySprite, this)
    this.uiExtraCells = [];
    this.addChild(this._inventorySprite);
  };

  isMouseInInventory() {
    if (this.isInventoryOpen()) {
      if (this._inventorySprite.isMouseIn()) {
        return true;
      }
    }
    return false;
  };

  openedInstance() {
    if (this.isInventoryOpen()) {
      return this.inventory;
    }
    return null;
  };

  openInventory() {
    this.inventory.open();
    this.openCategory($gameTemp._lastInvCategory);
  };

  closeInventory() {
    this.inventory.close();
  };

  isInventoryOpen() {
    return this.inventory.isInventoryActive();
  };

  openCategory(categoryId) {
    if (this.inventory.isSomeItemFocused()) {
      return;
    }
    if (!categoryId) {
      categoryId = 0;
    }
    categoryId = this._checkAvailableCategory(categoryId);
    $gameTemp._lastInvCategory = categoryId;
    this.inventory.loadItemsInCategory(categoryId);
  };

  showNextInvPage() {
    if (!this.isInventoryOpen()) {
      return;
    }
    this.inventory.showNextPage();
  };

  showPrevInvPage() {
    if (!this.isInventoryOpen()) {
      return;
    }
    this.inventory.showPrevPage();
  };

  clickInvItem(index) {
    if (!this.isInventoryOpen()) {
      return;
    }

    this.inventory.clickAt(index);
  };

  update() {
    Sprite.prototype.update.call(this);
    this.inventory.update();
  };

  terminate() {
    this.inventory.terminate();
  };

  clickInvFocusedItem(index) {
    if (!this.isInventoryOpen()) {
      return;
    }
    return this.inventory.clickAtFocusItem(index);
  };

  isMouseInIButton() {
    if (this._button && this._button.visible) {
      return this._button.cursorInButton();
    } else {
      return false;
    }
  };

  refreshInventory() {
    if (this.isInventoryOpen()) {
      this.openCategory($gameTemp._lastInvCategory);
    }
  };

  _checkAvailableCategory(categoryId) {
    if (!this._availableCategories) {
      const availableCategories = YsServices.equipmentService.getUIMapInventorySettings().availableCategories;

      if (!this._availableCategories) {
        this._availableCategories = [];
      }

      if (availableCategories.items === true) {
        this._availableCategories.push(0);
      }

      if (availableCategories.weapons === true) {
        this._availableCategories.push(1);
      }

      if (availableCategories.armors === true) {
        this._availableCategories.push(2);
      }

      if (availableCategories.keyItems === true) {
        this._availableCategories.push(3);
      }

      return this._checkAvailableCategory(categoryId);
    } else {
      if (this._availableCategories.contains(categoryId)) {
        return categoryId;
      } else {
        let nextCatId = categoryId + 1;
        if (nextCatId >= 4) {
          nextCatId = 0;
        }
        return this._checkAvailableCategory(nextCatId);
      }
    }
  };

}
